import React from 'react';
import MediaModulePlaceholder from 'app/components/mediaModule/MediaModulePlaceholder';
import { useLocation } from 'react-router';
import MediaView from 'app/components/mediaModule/content/MediaView';
import SwipeableMediaList from 'app/components/mediaModule/content/SwipeableMediaList';
const MAX_ELEMENTS_PER_VIEW = 4;
export default function MediaModuleContent(_ref) {
  let {
    data,
    districtName
  } = _ref;
  const location = useLocation();
  if (!data.length) {
    return /*#__PURE__*/React.createElement(MediaModulePlaceholder, {
      districtName: districtName,
      pathname: location.pathname
    });
  }
  if (data.length > MAX_ELEMENTS_PER_VIEW) {
    return /*#__PURE__*/React.createElement(SwipeableMediaList, {
      data: data
    });
  }
  return /*#__PURE__*/React.createElement(MediaView, {
    mediaList: data,
    "data-sentry-element": "MediaView",
    "data-sentry-component": "MediaModuleContent",
    "data-sentry-source-file": "MediaModuleContent.tsx"
  });
}